import classNames from 'classnames'
import React from 'react'

import { createStyles } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

const CardBody: React.SFC<CardBodyPropsWithStyles> = ({ classes, className = '', children, ...rest }) => {
  const cardBodyClasses = classNames({
    [classes.cardBody]: true,
    [className]: className !== undefined,
  })
  return (
    <div className={cardBodyClasses} {...rest}>
      {children}
    </div>
  )
}

type CardBodyPropsWithStyles = CardBodyProps & WithStyles<typeof styles>

type CardBodyProps = {
  className?: string
}

const styles = () =>
  createStyles({
    cardBody: {
      padding: '0.9375rem 1.875rem',
      flex: '1 1 auto',
    },
  })

export default withStyles(styles)(CardBody)
